import axios from 'axios'
import moment from 'moment'
import getConfig from 'next/config'
import { getDateDiff } from 'src/utils/date'

import server from 'src/config/server'
import { ExtendAxiosRequestConfig } from 'src/services/oms'

const { publicRuntimeConfig } = getConfig()

const axiosInstance = axios.create({
  validateStatus: (status) => {
    return status >= 200 && status < 400;
  }
})

axiosInstance.interceptors.request.use(
  function (req: ExtendAxiosRequestConfig) {
    req.time = { startTime: new Date() };
    return req;
  },
  (err) => {
    console.error(err)
    return err
  }
);

export const fetchReserveBrandInfoApi = async ({
  shortenBrandName
}: {
  shortenBrandName: string
}) =>
  axiosInstance.get(`${server.reserveServer}/brands/${shortenBrandName}`, {
    timeout: 10000
  })

export const fetchAvailableDateApi = async ({
  outletId,
  pax,
  month,
  iServer
}: {
  outletId: string
  pax: number
  month: string
  iServer: boolean
}) => {
  const resp = await axiosInstance.get(
    `${
      iServer ? server.reserveServer : publicRuntimeConfig.RESERVE_SERVER
    }/service-timings/available-by-month?outletId=${outletId}&pax=${pax}&month=${month}`,
    {
      timeout: 10000
    }
  )
  if (iServer && resp?.data && getDateDiff(`${month}-${new Date().getDate()}`, new Date()) <= 5) {
    const validDates = resp.data.some((date) => date.blockedReason === null)
    if (!validDates) {
      const currentMonth = new Date(month)
      return fetchAvailableDateApi({
        outletId,
        pax,
        month: moment(
          new Date(currentMonth.setMonth(currentMonth.getMonth() + 1))
        ).format('YYYY-MM'),
        iServer
      })
    }
  }
  return resp
}

export const fetchTimeslotApi = async ({
  outletId,
  pax,
  date,
  iServer
}: {
  outletId: string
  pax: number
  date: string
  iServer: boolean
}) => {
  const result = await axiosInstance.get(
    `${
      iServer ? server.reserveServer : publicRuntimeConfig.RESERVE_SERVER
    }/service-timings/available?outletId=${outletId}&pax=${pax}&date=${date}`,
    {
      timeout: 10000
    }
  )
  const tempTimeslots = (result?.data || []).reduce(
    (arr, timeslot) => [...arr, ...timeslot.availableTimeSlots],
    []
  )
  const sortedTimeslots = tempTimeslots.sort((a, b) => {
    const time1 = moment(a, 'HH:mm:ss')
    const time2 = moment(b, 'HH:mm:ss')
    return time1.diff(time2)
  })
  return Array.from(new Set(sortedTimeslots)) as string[]
}
